var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDynamoMoscow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 313.1 313.2",
    style: {
      enableBackground: "new 0 0 313.1 313.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#0033A0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.3,67.4c10.6-31.1,6.2-60.3-14.3-63.8c-23.1-3.9-40.9,19.7-45.7,60.1c-49.8,6.3-102.6,37.7-102.6,90.6 c0,56.9,64.9,64.9,74.1,22.6C53.5,173.9,56,91.7,124.2,75.7c-0.7,13.4,0,28.3,2.2,44.4c-8.4,5-17.7,9.7-27.8,14.2 c0,0,0.1,14.1,0.2,18.7c11.3-5.3,21.3-10.8,30.1-16.5c6.1,43.6,6.8,108-15.2,140.7c-13.4-6.6-27.1-13.6-42.8-13.6 c-43.9,0-44.9,46.2,4,46.2c16.7,0,31.3-5.9,44-15.4c75.3,41.2,171.6-4.7,171.6-105.2C290.4,133.9,246.5,83.1,185.3,67.4 M76.6,298.6 c-24,0-23.8-24.3-1-24.3c9,0,20.4,6,30.4,12.2C98.3,293.7,88.6,298.6,76.6,298.6 M166.1,25.9c10.7,1.9,12.9,19.4,7.1,38.9 c-11.1-1.9-22.6-2.7-34.5-2.2C143.2,40.4,153.8,23.8,166.1,25.9 M137,73.7c10.4-0.9,21.3-0.1,31.9,2.6c-6.1,13.5-16,26.7-29.5,35.4 C136.3,99.3,135.7,86,137,73.7 M128.9,285.8c35.5-34.8,53.6-97.8,60.5-125.3c-23.1-3.6-37.4-17.5-45.3-35.1 c16.2-12.4,28.3-28.8,36.1-45.5c35.6,13.8,65.9,49.8,65.9,111.3C246.1,259.3,187.6,312.1,128.9,285.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamoMoscow);
export default __webpack_public_path__ + "static/media/dynamo-moscow.f1b5d2d5078a42e57a5662f9e949ecf4.svg";
export { ForwardRef as ReactComponent };